import '../login.css';

import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import Show from '../../../common/components/show';
import clientConfig from '../../../config/client-config';
import ForgotPassword from '../components/forgotPassword';
import Login from '../components/login';
import RespondChallenge from '../components/respondChallenge';

export type LoginPageWindows = 'LOGIN' | 'RESPOND_CHALLENGE' | 'FORGOT_PASSWORD';

const LoginPage = () => {
  const [window, setWindow] = useState<LoginPageWindows>('LOGIN');

  return (
    <div className="flex-container">
      <Box className="left-box">
        <Show when={window == 'LOGIN'}>
          <Login setWindow={setWindow} />
        </Show>
        <Show when={window == 'RESPOND_CHALLENGE'}>
          <RespondChallenge />
        </Show>
        <Show when={window == 'FORGOT_PASSWORD'}>
          <ForgotPassword setWindow={setWindow} />
        </Show>
      </Box>
      <Box className="right-box">
        <Box>
          <img src={clientConfig.logos.dark} alt={clientConfig.branding.logoAltText} style={{ width: '100%' }} />
          <Typography variant="h5" component="p" style={{ color: 'white', textAlign: 'center', marginTop: '0.5rem' }}>
            <strong>{clientConfig.app.name}</strong>
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default LoginPage;
